import {
  logsItems
} from '@/api/logs'

const logs = {
  state: {

  },
  mutations: {

  },
  actions: {
    LogsItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        logsItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default logs



// WEBPACK FOOTER //
// ./src/store/modules/logs.js